export default "__VITE_ASSET__BlY16Po3__"